import { t } from 'i18next';
import localforage from 'localforage';
import { all, put, takeLatest } from 'redux-saga/effects';
import { container } from 'src/StaticContainer';
import { setLocatePreferences } from 'src/store/actions/locates/locatePreferences';
import type { ChangeLocateWarningPreferencesAction } from 'src/store/actions/locates/locatePreferences';
import { setSnackbar } from 'src/store/actions/ui';
import { select } from 'src/store/effects';
import { defaultLocatePreferences, LOCATE_PREFERENCES_KEY } from 'src/store/types/locates';
import type { LocatePreferences } from 'src/store/types/locates';

const log = container.get('Logger').getSubLogger({ name: 'locates-sagas' }, { component: 'lab' });

export function* handleChangeWarningPreference(action: ChangeLocateWarningPreferencesAction) {
    try {
        const oldLocatePreferences: LocatePreferences | null = yield select((state) => state.locates.locatePreferences);

        // Use default preferences if not yet initialized (e.g., LocatesV2Widget doesn't run legacy bootstrap)
        const basePreferences = oldLocatePreferences ?? defaultLocatePreferences;

        const updatedLocatePreferences: LocatePreferences = {
            ...basePreferences,
            warningPreferences: {
                ...basePreferences.warningPreferences,
                ...action.warningPreferences,
            },
        };

        yield put(setLocatePreferences(updatedLocatePreferences));

        if (action.forever) {
            yield localforage.setItem(LOCATE_PREFERENCES_KEY, updatedLocatePreferences);
        }
    } catch (e) {
        yield put(
            setSnackbar(t('widgets::lab::preferences::update-error', 'Updating locate warning preferences failed'), {
                variant: 'error',
            }),
        );

        if (e instanceof Error) {
            log.error({ message: 'Updating locate warning preferences failed', error: e });
        } else {
            log.fatal({ message: 'Unknown exception', details: e });
        }
    }
}

export function* locatesPreferencesSagas() {
    yield all([
        takeLatest('locatePreferences::changeLocateWarningPreferences', handleChangeWarningPreference),
        // takeLatest('locates::changeAutoAccept', handleChangeAutoAccept),
    ]);
}
